import { CatalogImage } from "../components/CatalogImage";
import { formatFitmentLabel } from "../lib/catalog";
import { moneyFormatter } from "../lib/money";
import { productSearchDescription } from "../lib/product-copy";
import type { Product } from "../types/catalog";

type ProductPageProps = {
  isAdmin: boolean;
  product: Product | null;
  stockLabel: string;
  onAddToCart: (product: Product) => void;
};

export function ProductPage({ isAdmin, product, stockLabel, onAddToCart }: ProductPageProps) {
  const productOverview = product ? productSearchDescription(product) : "";

  return (
    <section className="catalog page" aria-labelledby="product-title">
      {product ? (
        <article className="product-detail">
          <CatalogImage
            className="product-detail__image"
            alt={product.imageAlt}
            preset="productDetail"
            storageKey={product.imageStorageKey}
          />
          <div className="product-detail__body">
            <p className="eyebrow">{product.category}</p>
            <h1 id="product-title">{product.name}</h1>
            {productOverview ? <p>{productOverview}</p> : null}
            <p>{formatFitmentLabel(product)}</p>
            <dl className="product-detail__meta">
              <div>
                <dt>Brand</dt>
                <dd>{product.brand}</dd>
              </div>
              <div>
                <dt>Condition</dt>
                <dd>{product.condition}</dd>
              </div>
              <div>
                <dt>SKU</dt>
                <dd>{product.sku}</dd>
              </div>
              <div>
                <dt>Make</dt>
                <dd>{product.fitmentMake || "Any"}</dd>
              </div>
              <div>
                <dt>Model</dt>
                <dd>{product.fitmentModel || "Any"}</dd>
              </div>
              {(product.fitmentYearFrom || product.fitmentYearTo) ? (
                <div>
                  <dt>Year</dt>
                  <dd>
                    {product.fitmentYearFrom && product.fitmentYearTo && product.fitmentYearFrom !== product.fitmentYearTo
                      ? `${product.fitmentYearFrom} - ${product.fitmentYearTo}`
                      : String(product.fitmentYearFrom ?? product.fitmentYearTo)}
                  </dd>
                </div>
              ) : null}
              {product.fitmentEngine ? (
                <div>
                  <dt>Engine</dt>
                  <dd>{product.fitmentEngine}</dd>
                </div>
              ) : null}
              {stockLabel ? (
                <div>
                  <dt>{isAdmin ? "Stock" : "Availability"}</dt>
                  <dd>{stockLabel}</dd>
                </div>
              ) : null}
              {product.fitmentNotes ? (
                <div>
                  <dt>Notes</dt>
                  <dd>{product.fitmentNotes}</dd>
                </div>
              ) : null}
              <div>
                <dt>Price</dt>
                <dd>{moneyFormatter.format(product.priceKes)}</dd>
              </div>
            </dl>
            <button className="button" type="button" onClick={() => onAddToCart(product)}>
              Add to cart
            </button>
          </div>
        </article>
      ) : (
        <p className="empty-state">Product not found.</p>
      )}
    </section>
  );
}
